"use client";

export function ScrollToTop() {
  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div
      className="absolute bottom-0 right-0 mr-6 mb-6 group cursor-pointer"
      onClick={handleScrollToTop}
    >
      <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg" className="group-hover:fill-white transition-colors duration-300">
        <circle cx="24" cy="24.6006" r="23.5" stroke="white" />
        <path d="M35 30.6006L24.3333 16.6006L13 30.6006" stroke="white" strokeWidth="3" strokeLinejoin="round" className="group-hover:stroke-eurac-red" />
      </svg>
    </div>
  );
}
